import React from 'react';
import {observer} from 'mobx-react';

import Styled from 'lib/styles/styled-deprecated';
import computed from 'lib/mobx/computed';

import FormAutocompleteView from 'four-nets/ui/form/form-autocomplete-view';
import AutocompleteResultView from 'four-nets/ui/autocomplete/autocomplete-result-view';
import AutocompleteItemView from 'four-nets/ui/autocomplete/autocomplete-item-view';
import TextInputView from 'four-nets/ui/form/text-input-view';
import defaultStyles from './users-input-view.scss';

@Styled(defaultStyles)
@observer
class UsersInputView extends React.Component {
    textInput: ?TextInputView;

    @computed get autocompleteResults(): AutocompleteResultView[] {
        const field = this.props.field;

        return field.data.fields.map((fieldData) => {
            const {value: user} = fieldData;

            return (
                <AutocompleteResultView
                    key={user.username}
                    label={user.username}
                    onRemoveClick={() => {
                        field.data.remove(fieldData);
                    }}
                    />
            );
        });
    }

    setTextInput = ref => {
        this.textInput = ref;
    }

    onItem = () => {
        const textInput = this.textInput;

        if (textInput) {
            textInput.focus();
        }
    }

    keyForItem = user => user.username;

    elementForItem = user => (
        <AutocompleteItemView
            searchValue={this.props.searchField.data.value}
            title={user.username}
            subtitle={user.county}
            src={user.avatarUrl}
            />
    )

    render() {
        const {loading, autocompleteItems, searchField, field,
            onKeyDown, onBlur, onFocus, styles, ...rest} = this.props;

        const classNames = [styles.usersInput];

        if (field.data.fields.length) {
            classNames.push(styles.hasData);
        }


        return (
            <div
                className={classNames.join(' ')}
                >
                <FormAutocompleteView
                    field={field}
                    searchField={searchField}
                    autocompleteItems={autocompleteItems}
                    keyForItem={this.keyForItem}
                    elementForItem={this.elementForItem}
                    onItem={this.onItem}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    >
                    <TextInputView
                        innerRef={this.setTextInput}
                        field={searchField}
                        type='text'
                        loading={loading}
                        elementsBeforeInput={this.autocompleteResults}
                        dynamicWidth={true}
                        autoComplete={'off'}
                        {...rest}
                        styles={styles}
                        />
                </FormAutocompleteView>
            </div>
        );
    }
}

export default UsersInputView;
